export default "__VITE_ASSET__CKspf0TB__"